@if (product()?.id) {
  <div class="d-flex col-direction flex-wrap units-container">
    @if (product()?.meta?.grapes; as grapes) {
      @if (grapes.length > 0) {
        <div class="flex-grow-1">
          <span>Drue @for (grape of grapes; track grape; let last = $last) {
            <strong>
              <a [routerLink]="'/druer/' + getFriendlyName(grape)">{{ grape }}</a>@if (!last) {
              ,
            }</strong>
          }
        </span>
        </div>
      }
    }
    @if (product()?.meta?.port_type; as port_type) {
      <div>
        <span>Portvinstype <strong>{{ port_type }}</strong></span>
      </div>
    }
    @if (product()?.meta?.vintage; as vintage) {
      <div>
        <span>Årgang <strong>{{ vintage }}</strong></span>
      </div>
    }
    @if (product()?.meta?.serving; as serving) {
      <div>
        <span>Servering <strong>{{ serving }}</strong></span>
      </div>
    }
    @if (product()?.meta?.savingPotential; as savingPotential) {
      <div>
        <span>Gemme potentiale <strong>{{ savingPotential }}</strong></span>
      </div>
    }
    @if (product()?.meta?.alcohol; as alcohol) {
      <div>
        <span>Alkohol <strong>{{ alcohol.includes('%') ? alcohol : alcohol + ' %' }}</strong></span>
      </div>
    }
    @if (product()?.meta?.contentLabel; as contentLabel) {
      <div>
        <span>Indhold <strong>{{ contentLabel }}</strong></span>
      </div>
    }
    @if (product()?.closure; as closure) {
      <div>
        <span>Lukketype <strong>{{ closure }}</strong></span>
      </div>
    }
    @if (product()?.packaging; as packaging) {
      <div>
        <span>Emballage <strong>{{ packaging }}</strong></span>
      </div>
    }
    @if (product()?.meta?.allergens; as allergens) {
      <div>
        <span>Allergener <strong>{{ allergens.join(', ') }}</strong></span>
      </div>
    }
    @if (product()?.meta?.nutritionalInfoUrl; as nutritionalInfoUrl) {
      <div>
      <span>
        Næringsindhold <strong><a [href]="nutritionalInfoUrl" target="_blank">Se producentens varedeklaration</a></strong>
      </span>
      </div>
    }
</div>
}
